import checkIfItemIsInView from './checkIfItemIsInView';

/**
 * Returns true if at least one of the DOM Elements with the passed IDs are visible on the viewport
 * @param itemsDOMIds Lisf of DOM IDs
 */
const isOneOfThemInViewport = (itemsDOMIds: string[]): boolean => {
  const itemIsInView = itemsDOMIds.some(domId =>
    checkIfItemIsInView(document.getElementById(domId)),
  );

  return itemIsInView;
};

export default isOneOfThemInViewport;
